type MicroAppWindow = Window & {
    rawWindow?: Window;
};

/**
 * @description: 获取 MicroApp 微前端环境下的顶层 window 对象
 * @param {MicroAppWindow} currentWindow
 * @returns {MicroAppWindow}
 */
export function getTopLevelWindow(currentWindow: MicroAppWindow): MicroAppWindow {
    let topWindow: MicroAppWindow = currentWindow;
    while (topWindow.rawWindow && topWindow.rawWindow !== topWindow) {
        topWindow = topWindow.rawWindow as MicroAppWindow;
    }
    return topWindow;
}
